import React from 'react';
import { Routes, Route } from 'react-router-dom';

import MainPage from '../pages/chamadosPage';
import AdminPage from '../pages/adminPage';
import Layout from '../components/Layout';
import RequireAuth from '../components/RequireAuth/RequireAuth';
import Unauthorized from '../pages/unauthorizedPage';
import HomePage from '../pages/homePage';
import DashPage from '../pages/dashPage';
import Follow from '../pages/followPage';
import Project from '../pages/projectPage';

const AppRoutes: React.FC = () => (

        <Routes>
            <Route path="/" element={<Layout />}>
                <Route path="" element={<HomePage />} />
                <Route path="chamados" element={<MainPage />} />
                <Route path="follow" element={<Follow />} />
                <Route path="project" element={<Project />} />

                <Route element={<RequireAuth allowedRoles={['ADMIN']} />}>
                    <Route path="admin" element={<AdminPage />} />
                </Route>

                <Route element={<RequireAuth allowedRoles={['BI']} />}>
                    <Route path="dashboard" element={<DashPage />} />
                </Route>

                <Route path="unauthorized" element={<Unauthorized />} />
            </Route>
        </Routes>

);

export default AppRoutes;